import ComponentElement from 'components/component-element';
import {createElement} from 'methods/utils';

function Balloon($element, options = {}) {
    let defaultOptions = Object.assign({
        duration: 300,
    }, options);

    let $balloon = $element || createElement(`
        <div class="Map__balloon Map__balloon_hotel Map__balloon_external js-mapBalloon">
            <div class="Map__balloon-wrapper">
                <div class="Map__balloon-content js-balloonContent"></div>
                <div class="close"></div>
            </div>
        </div>
    `);

    ComponentElement.call(this, $balloon, defaultOptions);

    if (this.options.content) {
        this._render();
    }

    this._create();

    this.$ballonContent = this.$element.querySelector('.js-balloonContent');
    
    document.addEventListener('click', (event) => {
        const $target = event.target;

        if ((!$target.closest('.Map__balloon') || $target.closest('.Map__balloon .close')) && this.isOpened()) {
            this.close();
        }
    });
}

Balloon.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Balloon.prototype, 'constructor', {
    value: Balloon,
    enumerable: false,
    writable: true,
});

Balloon.prototype.open = function() {
    if (this.isOpened()) {
        return;
    }

    this.opened = true;
    this.$element.classList.add('opened');
    this._render();
};

Balloon.prototype.close = function() {
    this.$element.classList.remove('opened');

    setTimeout(() => {
        this.opened = false;

        this._clearLayout();
    },  this.options.duration);
};

Balloon.prototype.isOpened = function() {
    return this.opened;
};

Balloon.prototype._setContent = function(content) {
    if (!content) {
        return;
    }

    this.options.content = content;
    this._clearLayout();
    this._render();
};

Balloon.prototype._create = function() {
    if (document.querySelector('.js-mapBalloon')) {
        return;
    }

    document.body.insertAdjacentElement('beforeend', this.$element);
};

Balloon.prototype._clearLayout = function() {
    while (this.$ballonContent?.children?.length) {
        this.$ballonContent.children[0].remove();
    }
};

Balloon.prototype._render = function() {
    if (this.$ballonContent) {
        this.$ballonContent.insertAdjacentElement('afterbegin', this.options.content);
    }
};

export default Balloon;